// extracted by mini-css-extract-plugin
module.exports = {"menuItem":"MenuItem_menuItem__2AKaF","menuItemBody":"MenuItem_menuItemBody__-xqPG","nestedMenuItemList":"MenuItem_nestedMenuItemList__22uAA"};